import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, enumField } from './util';
import { generateArray } from '../utils/array';

export enum PlayoffTypes {
  double_elimination = 'double_elimination',
  elimination = 'elimination'
}

export enum PlayoffFormationTypes {
  common = 'common',
  by_standings = 'by_standings'
}

@ModelInstance({
  mappingFields: {
    rounds: 'rounds',
    final_rounds: 'finalRounds',
    third_place_rounds: 'thirdPlaceRounds',
    loser_final_rounds: 'loserFinalRounds',
    teams_count: 'teamsCount',
    type: 'type',
    formation_type: 'formationType',
    min_player_games_count: 'minPlayerGamesCount',
    min_player_time: 'minPlayerTime',
  },
  relation: {
    type: enumField(PlayoffTypes),
    formationType: enumField(PlayoffFormationTypes),
  }
})
export class PlayoffSettings extends BaseModel {
  rounds: number;
  finalRounds: number;
  thirdPlaceRounds: number;
  loserFinalRounds: number;
  teamsCount: number;
  type: PlayoffTypes;
  formationType: PlayoffFormationTypes;
  minPlayerGamesCount: number;
  minPlayerTime: number;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    settings: 'settings',
    tournament_id: 'tournamentId',
    tournament_stage_id: 'tournamentStageId',
    is_official: 'isOfficial',
    tournament_round_id: 'tournamentRoundId',
    division_id: 'divisionId',
    winner_place: 'winnerPlace',
  },
  relation: {
    settings: PlayoffSettings
  }
})
export class Playoff extends BaseModel {
  id: number;
  name: string;
  settings: PlayoffSettings;
  tournamentId: number;
  tournamentStageId: number;
  isOfficial: boolean;
  tournamentRoundId: number;
  divisionId: number;
  winnerPlace: number;
  private stages: {title: string, value: number}[] = [];

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}

  get stagesCount(): number {
    return Math.log(this.settings.teamsCount) / Math.log(2);
  }

  getPlayoffStages() {
    if (this.stages.length === 0 && this.settings.teamsCount) {
      const stagesCount = Math.log(this.settings.teamsCount) / Math.log(2);
      this.stages = generateArray(stagesCount).map(stage => {
        const playoffStage = this.settings.teamsCount / 2 ** stage;
        let title = '';
        if (playoffStage === 1) {
          title = 'Финал';
        } else {
          title = `1 / ${playoffStage}`;
        }
        return {
          value: stage,
          title
        };
      });
    }
    return this.stages;
  }
}
